import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '@prcins/utils';

@Component({
  selector: 'prcins-expired-policies',
  templateUrl: './expired-policies.component.html',
  styleUrls: ['./expired-policies.component.css']
})
export class ExpiredPoliciesComponent implements OnInit {

  constructor(private registrationProvider: RegistrationService) { }

  ngOnInit() {
    this.registrationProvider.invalidateEndorsementSession();
  }

}
